/*
 *   Copyright (c) 2021 vlinder Labs Private Limited
 *   All rights reserved.
 *   This software is proprietary of Vlinder Labs Pvt. Ltd and can not be distributed / used for any purpose outside of Vlinder Labs Pvt. Ltd without explicit written consent from the copyright owner.
 */
import { createAgent } from "@vlinder-web/plugin-agent-service-react";
import {
  HeaderService,
  IHeaderMethods,
  SettingsService,
  ISettingsMethods,
  CredentialFormService,
  ICredentialFormMethods,
  UserListService,
  IUserListMethodsMethods,
  CredentialPreviewService,
  ICredentialPreviewMethods,
  IIssueCredentialMethods,
  IssueCredentialService,
  ILoadingMethods,
  LoadingService,
  StaticPageContentService,
  IStaticPageContentMethods,
  IHoldersListMethods,
  HoldersListService,
} from "./components";

export type IssuedNewCredentialPageAgent = IHeaderMethods &
  ISettingsMethods &
  ICredentialFormMethods &
  IUserListMethodsMethods &
  ICredentialPreviewMethods &
  IIssueCredentialMethods &
  IStaticPageContentMethods &
  IHoldersListMethods &
  ILoadingMethods;

const getPlugins = () => {
  return [
    new HeaderService(),
    new SettingsService(),
    new CredentialFormService(),
    new UserListService(),
    new CredentialPreviewService(),
    new IssueCredentialService(),
    new LoadingService(),
    new StaticPageContentService(),
    new HoldersListService(),
  ];
};

export const getAgent = () => {
  return createAgent<IssuedNewCredentialPageAgent>({
    plugins: getPlugins(),
  });
};
